import Avatar from "@atlaskit/avatar";
import Tooltip from "@atlaskit/tooltip";
export interface WACAvatarProps {
    name: string;
    src: string;
    size: "small" | "medium" | "large";
    showTooltip?: boolean;
}
export const WACAvatar = (props: WACAvatarProps) => {
    return props.showTooltip ? (
        <Tooltip content={props.name}>
            <Avatar {...props} appearance="circle" />
        </Tooltip>
    ) : (
        <Avatar {...props} appearance="circle" />
    );
};
